import { Button } from '@weareberyl/design-system'
import { Modal } from 'antd'
import {
  InvoiceDocument,
  InvoiceQuery_invoice,
  useSettleInvoiceOffSessionMutation,
} from '~/gql/generated/graphql'

type Props = {
  invoice: InvoiceQuery_invoice
}
const SettleInvoice = ({ invoice }: Props) => {
  const [settle] = useSettleInvoiceOffSessionMutation({
    variables: { id: invoice.id },
    refetchQueries: [InvoiceDocument],
  })

  return (
    <Button
      title="Settle invoice"
      variant="danger"
      onPress={() => {
        Modal.confirm({
          title: 'You sure?',
          content: `This will debit ${invoice.currency_balance?.formatted_amount} immediately, is the customer expecting this?`,
          okText: 'Do it',
          onOk: settle,
        })
      }}
    />
  )
}

export default SettleInvoice
